module.exports = __webpack_public_path__ + "51ac2175e6290855a27edaef1dc40e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/xzkc.png
// module id = 287
// module chunks = 0